import { useState } from "react"
import { SubmitButton } from "@imago/api-client-for-react"
import { CURRENT_ONBOARDING_CONSENT, GAHTOnboarding_ID } from "@imago/model"
import { PaymentDialog, useBuyProduct, useOwns } from "../../PaymentDialog.tsx"

export function usePaid() {
	return useOwns(GAHTOnboarding_ID)
}

function Consent({checked, onChange, children}: {
	checked: boolean
	onChange: (checked: boolean) => void
	children: React.ReactNode
}) {
	return <div style={{display: 'flex', flexFlow: 'row', gap: '12px', alignItems: 'flex-start'}}>
		<input type="checkbox" style={{flex: '0 0 auto', marginBlockStart: '3px'}} checked={checked} onChange={e => onChange(e.currentTarget.checked)}/>
		<span className="text" style={{flex: '1'}}>{children}</span>
	</div>
}

function _Pay() {
	const buyGAHT = useBuyProduct({productID: GAHTOnboarding_ID, consent: CURRENT_ONBOARDING_CONSENT})!

	const [acceptedTerms, setAcceptedTerms] = useState(false)
	const [acceptedPrivacy, setAcceptedPrivacy] = useState(false)
	const [acceptedWaiver, setAcceptedWaiver] = useState(false)
	const allAccepted = acceptedTerms && acceptedPrivacy && acceptedWaiver

	return <>
		<form>
			<p>Starting Gender-Affirming Hormone Therapy at Imago costs <strong>€250</strong>.</p>
			<p>This includes the video-call with the physician and the support provided by our team.</p>
			<p><strong>To start your therapy, please read and accept all of the following:</strong></p>
			<Consent checked={acceptedTerms} onChange={setAcceptedTerms}>
				I accept the <a href="https://www.imago.tg/terms-of-use/" target="_blank" rel="noreferrer">Terms of Use</a>.
			</Consent>
			<Consent checked={acceptedPrivacy} onChange={setAcceptedPrivacy}>
				I accept the <a href="https://www.imago.tg/privacy-policy/" target="_blank" rel="noreferrer">Privacy Policy</a>.
			</Consent>
			<Consent checked={acceptedWaiver} onChange={setAcceptedWaiver}>
				I expressly request and consent to Imago beginning and fully performing the one-time Activation Service immediately, before the end of the 14-day statutory withdrawal period. I acknowledge that, once the Activation Service has been fully performed, I will lose my statutory right to withdraw from the contract for that service. I understand that the €250 Initial Fee is payable exclusively for the Activation Service. Any entitlement to an Initial Medical Consultation is a separate promotional benefit provided at no additional charge, has no cash value and does not form part of the price of the Activation Service.
			</Consent>
			<div className="row">
				<SubmitButton mutation={buyGAHT} vars={data => {}} disabledBecause={allAccepted ? undefined : 'Please accept the Terms of Use, the Privacy Policy, and the withdrawal-consent statement to continue.'}>Pay €250</SubmitButton>
			</div>
		</form>
		<PaymentDialog mutation={buyGAHT}/>
	</>
}

export function Pay() {
	const done = usePaid()
	return <section data-done={done ? true : undefined}>
		<h2>Pay</h2>
		{!done ? <_Pay/> : <></>}
	</section>
}
